import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { Role } from 'src/features/roles/utils/types';
import DeleteRoleFormModal from 'src/features/roles/components/forms/DeleteRoleFormModal';
import { rolesMessages } from 'src/features/roles/utils/messages';
import { Link } from 'react-router-dom';
import { PATH } from 'src/features/navigation/utils/constants';
import UpdateRoleFormModal from 'src/features/roles/components/forms/UpdateRoleFormModal';

export default function CellRoleActions({ row }: CellContext<Role, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateRoleFormModal
                        selectedRole={row.original}
                        semantics={{ entryName: formatMessage(rolesMessages.role).toLowerCase() }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateRoleFormModal>
                    <TooltipContent>
                        <FormattedMessage
                            defaultMessage={generalMessages.editEntry.defaultMessage}
                            id={generalMessages.editEntry.id}
                            values={{ entry: formatMessage(rolesMessages.role).toLowerCase() }}
                        />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteRoleFormModal
                        selectedRole={row.original}
                        semantics={{ entryName: formatMessage(rolesMessages.role).toLowerCase() }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteRoleFormModal>
                    <TooltipContent>
                        <FormattedMessage
                            defaultMessage={generalMessages.deleteEntry.defaultMessage}
                            id={generalMessages.deleteEntry.id}
                            values={{ entry: formatMessage(rolesMessages.role).toLowerCase() }}
                        />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Link to={`/${PATH.ADMINISTRATION}/roles/${row.original.id}`}>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EXPAND} />
                            </Button>
                        </Link>
                    </TooltipTrigger>
                    <TooltipContent>
                        <FormattedMessage {...rolesMessages.dashboard} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
